import { createFeatureSelector, createSelector } from "@ngrx/store";
import { FeatureKeys } from "../app.reducer";
import * as fromReducer from './vehicle.reducer';
import * as fromAdapter from './vehicle.adapter';

export const selectVehicleFeature = createFeatureSelector<fromReducer.VehiclesState>(
    FeatureKeys.VEHICLES
  );
  
  /* To select the all vehicles from vehicles state */
  export const selectAllVehicles = createSelector(
    selectVehicleFeature,
    (state: fromReducer.VehiclesState) => fromAdapter.getAllvehicles(state.vehicles.data)
  );

  export const selectVehiclesMake = createSelector(
    selectVehicleFeature,
    (state: fromReducer.VehiclesState) => fromAdapter.getVehiclesMake(state.vehicles.data)
  );

  /* To Select all vehicles as per Modeled data*/
  export const modeledAllVehicles = createSelector(
    selectVehicleFeature,
    (state: fromReducer.VehiclesState) => fromAdapter.transformVehicleInventory(state.allVehicles.data, true)
  )

  export const modeledValidVehicles = createSelector(
    selectVehicleFeature,
    (state: fromReducer.VehiclesState) => fromAdapter.transformVehicleInventory(state.allVehicles.data, false)
  )

  export const selectLoading = createSelector(
    selectVehicleFeature,
    (state: fromReducer.VehiclesState) => state.vehicles.loading
  );

  export const selectBulkStatusLoading = createSelector(
    selectVehicleFeature,
    (state: fromReducer.VehiclesState) => state.bulkStatusLoading
  );

  export const selectVehiclesCount = createSelector(
    selectVehicleFeature,
    (state: fromReducer.VehiclesState) => state.count
  )

  export const selectVehicles = createSelector(
    selectVehicleFeature,
    (state: fromReducer.VehiclesState) => state.vehicles.data
  )

  export const selectSyncStatus = createSelector(
    selectVehicleFeature,
    (state: fromReducer.VehiclesState) => state.status
  );
  
  export const selectAllVehiclesFromInventory = createSelector(
    selectVehicleFeature,
    (state: fromReducer.VehiclesState) => state.allVehicles.data
  )

  export const selectVehiclesLoaded = createSelector(
    selectVehicleFeature,
    (state: fromReducer.VehiclesState) => state.allVehicles.loaded
  );

  export const selectOnlineVehiclesCount = createSelector(
    selectVehicleFeature,
    (state: fromReducer.VehiclesState) => fromAdapter.findOnlineVehicleCount(state.allVehicles.data)
  )
